/* tslint:disable:ban-types */

// https://github.com/reworkcss/css/issues/139
/* tslint:disable-next-line:no-var-requires  */
const parse = require('css/lib/parse');
import { Declaration, Media, Rule, Stylesheet } from 'css';

declare var window: Window & {
  msCrypto?: {};
};

export function DontTreeShake(consturctor: Function, key?: string) {
  const definedKey = key ?? randomKey();

  // tslint:disable-next-line:no-any
  const myWindow = window as any;
  myWindow.retain = { ...myWindow.retain, [definedKey]: consturctor };
}

export function DontTreeShakeModuleAndComponents(
  consturctor: Function,
  key: string,
  components: Function[],
) {
  DontTreeShake(consturctor, key);
  components.forEach((fn, i) => DontTreeShake(fn, `${key}_${i}`));
}

function randomKey() {
  const crypto = window.crypto || window.msCrypto;
  const array = new Uint32Array(1);
  const values = crypto.getRandomValues(array);
  return values.toString();
}

/**
 * @description A method to wrap style tag contents in a similar fashion as angular is doing for encapsulating component styles
 *
 * @param content <style> tag contents
 * @param rootSelector selector to wrap provived style selectors
 *
 * @example
 *   wrapStyleTagSelectorsWithRootSelector(
 *    `a { color: blue !important }`,
 *    '#id',
 *   )
 *
 *   will generate
 *    #id a {color: blue !important}
 *
 * Currently it's only allowing of mapping regular css rules and media queries.
 *  It will remove any selectors from the list below
 *    comments, charsets, custom-media, document, font-face, host, import, keyframes, namespace, page, supports
 */
export function wrapStyleTagSelectorsWithRootSelector(
  content: string,
  rootSelector: string,
) {
  let styles: Stylesheet;
  try {
    styles = parse(content);
  } catch (e) {
    return content;
  }

  const rules = styles.stylesheet?.rules;
  if (!rules) return content;

  let result = '';

  for (const rule of rules) {
    // needs to be done in order. That's why not passing whole rules arr to the helper fn
    if (isRule(rule)) {
      result += rulesToWrappedString([rule], rootSelector);
    }

    if (isMedia(rule) && rule.rules) {
      result += `@media ${rule.media} {${rulesToWrappedString(
        rule.rules,
        rootSelector,
      )}}`;
    }
  }

  return result;
}

function rulesToWrappedString(rules: Rule[], rootSelector: string) {
  let result = '';
  for (const rule of rules) {
    if (isRule(rule)) {
      const wrappedSelectorsString = rule.selectors
        ?.map((s) => `${rootSelector} ${s}`)
        .join(', ');

      const declarationsStr = rule.declarations
        ?.filter(isDeclaration)
        .filter(({ property, value }) => Boolean(property) && Boolean(value))
        .map((d) => `${d.property}: ${d.value}`)
        .join('; ');

      result += `${wrappedSelectorsString} {${declarationsStr}}`;
    }
  }

  return result;
}

/* tslint:disable-next-line:no-any */
function isRule(object: any): object is Rule {
  return 'selectors' in object;
}

/* tslint:disable-next-line:no-any */
function isDeclaration(object: any): object is Declaration {
  return 'property' in object && 'value' in object;
}

/* tslint:disable-next-line:no-any */
function isMedia(object: any): object is Media {
  return 'media' in object;
}
